import styled from 'styled-components';
/* istanbul ignore file */

export const actionIconStyle = {
  width: 30,
  margin: '11px 3px 0 0',
  height: 30,
  padding: '0'
};
export const gridContainerStyle = {
  '&&': {
    position: 'relative',
    padding: '2px 18px',
    overflow: 'hidden'
  }
};
export const NoRecordsDiv = styled.div.withConfig({
  displayName: "commonStyles__NoRecordsDiv",
  componentId: "f6hpob-0"
})(["margin-left:1em;color:", ";"], props => props.theme.palette.text.primary);
export const NoRecordsPrintDiv = styled.div.withConfig({
  displayName: "commonStyles__NoRecordsPrintDiv",
  componentId: "f6hpob-1"
})(["font-size:1.2em;margin-left:1em;@media print{p{color:black;padding:1em;}}"]); // NOTE header are from FACESHEET not from printHeader or printFooter
// https://github.com/gregnb/react-to-print/issues/387
// https://plnkr.co/edit/lWk6Yd?preview
// header issue react to print

export const pageStyle = `
  @page {
    size: portrait !important;
    margin: 10mm 2mm !important;
  }
  @media print {
    body {
    -webkit-print-color-adjust: exact;
  }
  }
`;
export const medsPageStyle = `@page { size: auto;  margin: 20mm 15mm important!; }`;
export const facesheetPageStyle = `@page { size: auto;  margin: 20mm important!; } @media print { body { -webkit-print-color-adjust: exact; } }`;
export default {
  gridContainerStyle,
  actionIconStyle,
  NoRecordsDiv,
  NoRecordsPrintDiv,
  pageStyle,
  medsPageStyle,
  facesheetPageStyle
};